import React from "react";
import { IconReload } from "@veneer/core";
import { isRecurrentAppointment } from "./agendaCalendarUtils";

interface RecurrenceIndicatorProps {
  appointmentTypeID: number;
  /** When omitted the icon renders as a non-interactive visual indicator. */
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const RecurrenceIndicator: React.FC<RecurrenceIndicatorProps> = ({
  appointmentTypeID,
  onClick,
}) => {
  if (!isRecurrentAppointment(appointmentTypeID)) return null;

  if (!onClick) {
    return (
      <span
        className="recurrenceIndicatorIcon"
        aria-label="Recurring"
        title="Recurring"
      >
        <IconReload size={12} />
      </span>
    );
  }

  return (
    <button
      type="button"
      className="recurrenceIndicatorBtn"
      onClick={onClick}
      title="Edit recurrence"
      aria-label="Edit recurrence"
    >
      <IconReload size={12} />
    </button>
  );
};

export default RecurrenceIndicator;
